import { apiGet, apiPatch, apiPost, apiDelete } from "../shared/apiClient";

// ── Profile ──────────────────────────────────────────────────────────────────
export interface ProfilePatch {
  name?: string;
  avatar?: string | null;
  timezone?: string;
  language?: string;
  onboarded?: boolean;
}
export const updateProfile = (patch: ProfilePatch) =>
  apiPatch<{ id: string; name: string; email: string; avatar?: string; timezone?: string; language?: string; onboarded: boolean }>(
    "/settings/profile",
    patch,
  );

export const changePassword = (currentPassword: string, newPassword: string) =>
  apiPatch<{ ok: boolean }>("/settings/change-password", { currentPassword, newPassword });

// ── 2FA ──────────────────────────────────────────────────────────────────────
export interface TwoFactorSetup {
  secret: string;
  otpauthUrl: string;
  qrDataUrl: string;
  recoveryCodes: string[];
}
export const get2FAStatus = () => apiGet<{ enabled: boolean }>("/settings/2fa/status");
export const setup2FA = () => apiPost<TwoFactorSetup>("/settings/2fa/setup");
export const enable2FA = (code: string) => apiPost<{ enabled: boolean }>("/settings/2fa/enable", { code });
export const disable2FA = (code: string) => apiPost<{ enabled: boolean }>("/settings/2fa/disable", { code });

// ── Workspace ────────────────────────────────────────────────────────────────
export interface WorkspacePatch {
  name?: string;
  slug?: string;
  logo?: string;
  defaultCategory?: string;
  primaryColor?: string;
}
export const updateWorkspace = (id: string, patch: WorkspacePatch) =>
  apiPatch<{ _id: string; name: string; slug: string; logo?: string; primaryColor?: string; defaultCategory?: string }>(
    `/workspaces/${id}`,
    patch,
  );
export const deleteWorkspace = (id: string) => apiDelete<{ id: string }>(`/workspaces/${id}`);
